
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { TradeRequest, TradeResult } from '../../types/trading';
import { HotDEX } from '../../programs/src/trading';
import { ActionResponse, safeAction } from '../../lib/utils/safe-action';
import { rateLimit } from '../../lib/utils/rate-limit';
// import { db } from '../../server/db';

/**
 * API Endpoint: /api/trade
 * Handles token purchases and sales.
 */
export const executeTradeApi = async (
  request: TradeRequest, 
  currentMarketPrice: number
): Promise<ActionResponse<TradeResult>> => {
    
    // 1. Rate Limiting (Simulated per wallet)
    if (!rateLimit(request.walletAddress, 5, 60000)) {
        return { success: false, error: "Rate limit exceeded. Please try again later." };
    }

    return safeAction(async () => {
        // 2. Validation
        if (!request.walletAddress) throw new Error("Wallet not connected.");
        if (request.amountIn <= 0) throw new Error("Invalid trade amount.");
        if (!request.chain) throw new Error("Chain not specified.");
        if (!request.network) throw new Error("Network not specified.");

        // 3. Wallet Check (Simulation)
        if (request.amountIn > 1000000) {
            throw new Error("Insufficient funds in wallet.");
        }

        // 4. Default Supply if missing (Mock)
        if (!request.tokenSupply) {
            request.tokenSupply = 1_000_000_000; // 1 Billion default
        }

        // 5. Call Smart Contract / DEX (On-Chain Simulation)
        // We pass the network context implicitly here, though in a real RPC calls it would configure the connection
        const result = await HotDEX.executeSwap(request, currentMarketPrice);

        // 6. Index Transaction (Off-Chain DB)
        // This persists the trade to the user's history
        /* await db.transaction.create({
            data: {
                userId: request.walletAddress, // Using wallet as ID for demo
                txHash: result.txHash,
                chain: request.chain,
                network: request.network,
                type: 'SWAP',
                status: 'CONFIRMED',
                tokenInMint: request.side === 'BUY' ? 'SOL' : request.tokenAddress,
                tokenOutMint: request.side === 'BUY' ? request.tokenAddress : 'SOL',
                amountIn: request.amountIn.toString(),
                amountOut: result.amountOut.toFixed(6),
                feeAmount: (result.fee + (result.tokenTax || 0)).toFixed(6),
                blockNumber: result.blockNumber,
                explorerUrl: `https://solscan.io/tx/${result.txHash}?cluster=${request.network}`
            }
        }); */

        return result;
    }, "Trade failed due to network error.");
};
